var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"home-content",staticStyle:{"padding-top":"50px"}},[_vm._v(" 1321321 ")])}
var staticRenderFns = []

export { render, staticRenderFns }